<template>
  <div v-if="visible" class="metadata">
    <ncs-empty-result v-if="emptyResult"/>
    <template v-else>
      <ncs-page-selector/>
      <div @scroll="scrollTop" ref="scrollTop" class="scroll-top">
        <div ref="scrollTopContent"></div>
      </div>
      <div class="table-responsive" @scroll="scrollBottom" ref="scrollBottom">
        <table class="navigation-table table table-stripped table-hover table-sm">
          <thead>
          <tr>
            <th></th>
            <th></th>
            <template v-if="learners">
              <th v-for="field in $ncsConfig.cedel2.navigation.Learners">{{$t(`result.context.header.document.${field}`)}}
              </th>
            </template>
            <template v-else>
              <th v-for="field in $ncsConfig.cedel2.navigation.Native">{{$t(`result.context.header.document.${field}`)}}
              </th>
            </template>
          </tr>
          </thead>
          <tbody ref="tableBody">
          <tr v-for="(row, index) in result.navigation"
              :class="{'navigation-row-context-link': $ncsConfig.result.kwic.contextOnRowClick}"
              @click="$ncsConfig.result.kwic.contextOnRowClick && showText(row, currentOffset + index + 1)">
            <td>
              <a v-if="$ncsConfig.result.kwic.contextOnRowClick"
                 @click="showText(row, currentOffset + index + 1)" href="#">{{currentOffset + index + 1}}</a>
              <span v-else>{{currentOffset + index + 1}}</span>
            </td>
            <td>
              <vue-plyr v-if="row.medium === 'Spoken'" @click.native.stop="" :options="{controls: ['play'], iconUrl: './images/plyr.svg'}">
                <audio :src="`./audio/${row.filename}.mp3`" preload="none"/>
              </vue-plyr>
            </td>
            <template v-if="learners">
              <td v-for="field in $ncsConfig.cedel2.navigation.Learners">{{$ncsConfig.fieldValue(row[field])}}</td>
            </template>
            <template v-else>
              <td v-for="field in $ncsConfig.cedel2.navigation.Native">{{$ncsConfig.fieldValue(row[field])}}</td>
            </template>
          </tr>
          </tbody>
        </table>
      </div>
      <ncs-page-selector/>
    </template>
  </div>
</template>
<script>
  import get from 'lodash/get'
  import {mapState} from 'vuex'

  export default {
    mounted() {
      this.initScroll()
    },
    updated() {
      this.initScroll()
    },
    computed: {
      ...mapState({
        visible: s => s.api.resultDisplay === 'navigation',
        executionState: s => s.api.executionState,
        result: s => s.api.result,
        currentOffset: s => s.pagination.currentOffset
      }),
      learners() {
        return get(this.$store.state.filters.byId, ['ncs_documents.subcorpus', 'value']) === 'Learners'
      },
      emptyResult() {
        return this.result.navigation.length === 0
      }
    },
    methods: {
      showText(row, example) {
        this.$store.dispatch('api/executeDetail', {type: 'text', query: {text: row.id, example}})
        this.$ga.page(`/search/text`)
      },
      initScroll() {
        // We have to check the execution state and result type, because we need to update scroll HTML
        // with every render, and it can happen even if the component dom is not rendered.
        // For example, when we access context api state changes and, since it's bound to this component
        // through computed properties, the updated hook will be called, but the component is not rendered.
        // Pressing back button will restore previous result and update hook will be called. This time the
        // component will be rendered and we have to initialize the top scroll again.
        if (this.visible && this.executionState === 'completed' && !this.emptyResult) {
          this.$refs.scrollTopContent.style.width = `${this.$refs.tableBody.scrollWidth}px`
        }
      },
      scrollTop() {
        this.$refs.scrollBottom.scrollLeft = this.$refs.scrollTop.scrollLeft
      },
      scrollBottom() {
        this.$refs.scrollTop.scrollLeft = this.$refs.scrollBottom.scrollLeft
      }
    }
  }
</script>
<style lang="scss" scoped>
  .scroll-top {
    overflow-x: scroll;

    & > div {
      height: 1px;
    }
  }

  .navigation-table {
    font-size: 14px;
  }
</style>